import { defineNuxtMiddleware } from '@nuxtjs/composition-api';
import { getUser } from '~/features/auth';

export default defineNuxtMiddleware(async function GuestMiddleware({ redirect, i18n }) {
  const user = await getUser();
  if (user) {
    redirect(`/${i18n.locale}/`);
  }
});
